import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar as BaseAvatar } from "native-base";
const StatusIndicator = ({ status, hasBorder = true }) => (_jsx(BaseAvatar.Badge, { bg: `${status === "active" ? "green" : "rose"}.500`, borderWidth: hasBorder ? 1 : 0, size: 2, top: 0, zIndex: 1 }));
export default StatusIndicator;
